import React from 'react';

import { Form, FormItemProps, Select } from 'antd';
import { t } from 'i18next';

import { bookingType } from '../utils/const';


interface Props {
  formItemProps?: FormItemProps;
}

export function SelectBookingType({ formItemProps }: Props) {
  return (
    <Form.Item
      label={t('table.booking-type')}
      name="bookingType"
      {...formItemProps}
    >
      <Select>
        {
          bookingType.map((name, value) => (
            <Select.Option key={name} value={value}>
              {t(`form-items.select.booking-type.${name}`)}
            </Select.Option>
          ))
        }
      </Select>
    </Form.Item>
  );
}
